import { useEffect } from "react";
import { Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import {
  setWfhs,
  setIsPunchedOut,
  setShowPunchWarning
} from "state/slices/wfh/wfhSlice";

import {
  useGetWfhsQuery,
} from "state/slices/wfh/wfhApiSlice";

import WFHTable from "components/WFHTable";
import WarningAlert from 'common/Alert';

import { isAllowedToDo } from "permissions-hub";
import { ACCEPTED_PERMISSIONS } from "constants";

const WFHManagement = ({ permissions }) => {
  const dispatch = useDispatch();

  const wfhs = useSelector((state) => state.wfh.wfhs);
  const showPunchWarning = useSelector((state) => state.wfh.showPunchWarning);
  const { userInfo } = useSelector((state) => state.auth);

  const isAllowedToDelete = isAllowedToDo(
    ACCEPTED_PERMISSIONS["delete"],
    permissions,
  );

  const {
    data,
    refetch,
    isLoading: isWFHsLoading,
  } = useGetWfhsQuery(userInfo?.employeeId);

  useEffect(() => {
    if (data) {
      dispatch(setWfhs(data.wfhs));
      dispatch(setIsPunchedOut(data.isPunchedOut));
      dispatch(setShowPunchWarning(data.showPunchWarning));
    }
  }, [data, dispatch]);

  return (
    <>
      {
        showPunchWarning &&
        <Col sm={7}>
          <WarningAlert 
            icon={<i className="bi bi-exclamation-triangle-fill me-2"></i>}
            message="<p class='mb-0'>You Missed the punch out. Please make sure to punch within shift time frame.</p>" 
          />
        </Col>
      }
      <Col sm={12}>
        <WFHTable
          wfhs={wfhs}
          isAllowedToDelete={isAllowedToDelete}
          isWFHsLoading={isWFHsLoading}
          refetch={refetch}
          showSelfies={true}
        />
      </Col>
    </>
  );
};

export default WFHManagement;
